import script from "./FundamentalCardVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./FundamentalCardVideo.vue?vue&type=script&setup=true&lang=js"

import "./FundamentalCardVideo.vue?vue&type=style&index=0&id=63beecd2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63beecd2"]])

export default __exports__